// Показать еще
var indexWebinars = 0;
$('#showmorewebinars').click(function () {
    var limitWebinars = Number.parseInt($('#showmorewebinars').attr('data-limit-webinars'));
    var offsetWebinars = Number.parseInt($('#showmorewebinars').attr('data-offset-webinars'));
    indexWebinars === 0 ? indexWebinars = offsetWebinars : indexWebinars = indexWebinars + limitWebinars;
    $.ajax({
        method: "POST",
        url: '/webinars/btnmore',
        data: {
            limitWebinars: limitWebinars,
            offsetWebinars: indexWebinars,
        },
        success: function (msg) {
            $('.more-webinars').append(msg[0]);
            if (msg[1]) {
                $('#showmorewebinars').detach();
            }
        },
        dataType: "json"
    });
});
